import { useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "./analytics";
import { redactPath } from "../lib/redactPath";

/**
 * Returns a stable `track(event, properties)` for firing custom analytics
 * events at key product moments (match_revealed, search_performed, etc.).
 */
export const useAnalytics = () => {
  const track = useCallback(
    (event, properties) => trackEvent(event, properties),
    []
  );
  return { track };
};

/**
 * Fires `page_view` on every route change. Mount once, app-wide (in Layout).
 * De-duped so a re-render on the same path doesn't double-count.
 */
export const usePageViews = () => {
  const location = useLocation();
  const lastPath = useRef(null);
  useEffect(() => {
    const path = location.pathname;
    if (lastPath.current === path) return;
    lastPath.current = path;
    // De-duped on the real path, reported as the route shape — the reset and
    // verify routes carry a single-use token in the path itself.
    trackEvent("page_view", { path: redactPath(path) });
  }, [location.pathname]);
};

export default useAnalytics;
